import Axios from 'axios' //在http.js引入axios
import {getAppToken,removeAppToken} from './utils/auth';//setAppToken
import {Message,MessageBox} from 'element-ui';
import { debounce } from 'throttle-debounce';
import router from './router';
const errorMessage = debounce(500, (message, type = 'error') => {
  Message({
    message: message,
    duration: 1500,
    type: type
  })
})
const confirmMessage = debounce(1000, (message,callback) => {
  return MessageBox.confirm(message, '提示', {
    confirmButtonText: '确定',
    showCancelButton: false,
    closeOnClickModal: false,
    closeOnPressEscape: false,
    showClose: false,
    type: 'warning'
  }).then(res=>{
    if(typeof callback === 'function'){
      callback();
    }
  });
})
//使用create方法创建axios实例
const service = Axios.create({
  baseURL:process.env.NODE_ENV==='production'?'/api/':'/' ,
  timeout: 15000, // 请求超时时间
  method: 'post',
  headers: {
    'Content-Type': 'application/json;charset=UTF-8'
  }
})

service.interceptors.request.use(
  (config) => {
    config.headers['Admin-Token'] = getAppToken();
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
)

// 添加响应拦截器
service.interceptors.response.use(
  response => {
    let res = response.data;
    // 文件类型特殊处理
    if (response.status === 200 && response.config.responseType === 'blob') {
      if (response.headers['content-disposition'] || (response.headers['content-type'] && response.headers['content-type'].indexOf('application/pdf') !== -1)) {
        return response
      } else if (response.data) {
        const resultBlob = new Blob([response.data], { type: 'application/json' })
        const fr = new FileReader()
        fr.onload = function() {
          const result = JSON.parse(this.result)
          // 附件下载反馈的302 忽略
          if (result.msg && result.code !== 302) {
            errorMessage(result.msg, result.code === 1 ? 'success' : 'error')
          }
        }
        fr.readAsText(resultBlob)
      }
    } else if (res.code !== 0) {
      // 302	登录已失效
      if(res.code === 302) {
        if (res.data && res.data.extra === 1) {
          confirmMessage(`您的账号${res.data.extraTime}在别处登录。如非本人操作，则密码可能已泄漏，建议修改密码`,()=>{
            //跳转登录
            removeAppToken();
            // location.href = `${window.location.origin}/login`;
            router.push({name:'login'});
          });
        }
      }else {
        if(res.msg) {
          errorMessage(res.msg)
        }
      }
      return Promise.reject(res);
    }
    return res;
  },
  error => {
    if(['ERR_NETWORK'].includes(error.code)){
      errorMessage('网络出差了，请稍后重试')
    }
    if(['ECONNABORTED'].includes(error.code)){
      errorMessage('当前网络较差，请稍后重试')
    }
    if (error.response) {
      let response = error.response
      if (response.status === 500) {
        errorMessage('系统错误')
      } else if (response.data && response.data.msg) {
        errorMessage(response.data.msg)
      }
    }
    return Promise.reject(error)
  }
);

export default service;

